import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="bg-[#0f0f0f] py-24" data-id="element-127">
      <div className="mx-auto max-w-4xl px-6" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative overflow-hidden rounded-3xl border border-amber-500/30 bg-[#141414] p-8 text-center md:p-16" data-id="element-129">
          <div className="absolute top-0 left-1/2 h-1 w-1/2 -translate-x-1/2 bg-gradient-to-r from-transparent via-amber-500 to-transparent opacity-50" data-id="element-130"></div>

          <div className="mb-2 inline-block rounded-full bg-amber-500/20 px-4 py-1 text-sm font-bold text-amber-400" data-id="element-131">
            🔥 Oferta por tiempo limitado
          </div>
          <div className="flex items-center justify-center gap-4" data-id="element-132">
            <span className="text-2xl font-medium text-gray-500 line-through md:text-3xl" data-id="element-133">
              $19
            </span>
            <h2 className="text-5xl font-black text-white md:text-7xl" data-id="element-134">
              $6.36
            </h2>
            <span className="rounded-lg bg-green-500/20 px-3 py-1 text-lg font-bold text-green-400" data-id="element-135">
              -67%
            </span>
          </div>
          <p className="mt-2 text-sm font-medium uppercase tracking-widest text-gray-500" data-id="element-136">
            Pago único
          </p>

          <div className="mx-auto mt-8 max-w-lg" data-id="element-137">
            <p className="text-xl text-gray-300" data-id="element-138">
              No estás pagando "información".
              <br data-id="element-139" />
              <span className="font-bold text-white" data-id="element-140">
                Estás pagando estructura para salir del pánico en horas.
              </span>
            </p>
          </div>

          <div className="mt-10" data-id="element-141">
            <a href="https://vitalrutinas.com/cart/53260710904176:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full rounded bg-amber-500 px-8 py-4 text-xl font-bold text-black shadow-lg shadow-amber-500/20 transition-all hover:scale-105 hover:bg-amber-400 md:w-auto" data-id="element-142">
              Descargar el Kit Ahora
            </a>
          </div>

          <div className="mx-auto mt-8 max-w-2xl rounded-xl bg-black/30 p-6 text-sm text-gray-400" data-id="element-143">
            <div className="mb-2 flex justify-center" data-id="element-144">
              <Lock className="h-5 w-5 text-gray-500" data-id="element-145" />
            </div>
            <p className="font-semibold text-gray-300" data-id="element-146">
              Garantía (recomendación simple)
            </p>
            <p className="mt-2" data-id="element-147">
              Si lo lees y lo ejecutas y sientes que no te dio claridad
              operativa, te conviene pedir reembolso. La idea es simple: este
              kit solo sirve si te devuelve tablero.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}